module.exports = __webpack_public_path__ + "static/img/104912.6e07e404.png";